module.exports = new __parcel__URL__("no-team-avatar.fa4b7eb2.svg").toString();